import * as React from 'react';

import {appHistory} from '../../../history';

import {useToggleComparison} from '../editions/a-b-testing/graphql/hooks';
import {NewEditionModal} from '../editions/new-edition-modal';
import {BroadcastMutations} from '../graphql-wrappers/broadcast/broadcast-mutations';
import {getFieldsToCompare} from '../utils';

/*
This is really just a wrapper around our new editon modal, but is specific for
broadcasts. We have a lot of places in our code where we allow creating new
broadcasts, and this prevents us from having to import our mutations, the modal,
and wire up pushing to the new broadcast page.

This does not work for creating newsletter editions.
*/

type Props = {
    isOpen: boolean;
    onClose: () => void;
    defaultView?: string;
    initialSelectedCategoryOrTemplateApiId?: string;
};

export function NewBroadcastModal(props: Props) {
    const {toggleComparison} = useToggleComparison();
    const shouldToggleComparisonRef = React.useRef(false);
    // @ts-expect-error
    let fieldsToCompare = [];

    return (
        <BroadcastMutations>
            {({onCreate, onDuplicate}) => (
                <NewEditionModal
                    // TODO: This is a hack to get flow to pass, but we don't technically
                    // need a campaignId here, so I'm hacking it.
                    campaignId='broadcast'
                    type='broadcasts'
                    initialSelectedCategoryOrTemplateApiId={
                        props.initialSelectedCategoryOrTemplateApiId
                    }
                    isOpen={props.isOpen}
                    onClose={props.onClose}
                    onCreateEdition={(name) => {
                        return onCreate(
                            name,
                            shouldToggleComparisonRef.current,
                            // @ts-expect-error
                            getFieldsToCompare(fieldsToCompare)
                        ).then((newBroadcast) => {
                            if (newBroadcast && newBroadcast.edition) {
                                const edition = newBroadcast.edition;
                                if (shouldToggleComparisonRef.current) {
                                    appHistory.push(`${edition.htmlUrlPath}/a-b-test`);
                                } else {
                                    appHistory.push(edition.htmlUrlPath);
                                }
                            }
                        });
                    }}
                    onDuplicateEdition={(
                        editionId: string,
                        campaignId: string,
                        name?: string | null
                    ) => {
                        return onDuplicate(editionId, name).then((newBroadcast) => {
                            if (newBroadcast) {
                                const edition = newBroadcast.edition;
                                if (shouldToggleComparisonRef.current) {
                                    toggleComparison({
                                        editionId: edition.id,
                                        shouldBeComparison: true,
                                        // @ts-expect-error
                                        fieldsToCompare: getFieldsToCompare(fieldsToCompare),
                                    }).then(() => {
                                        appHistory.push(`${edition.htmlUrlPath}/a-b-test`);
                                    });
                                } else {
                                    appHistory.push(edition.htmlUrlPath);
                                }
                            }
                        });
                    }}
                    // @ts-expect-error
                    defaultView={props.defaultView}
                    toggleComparison={(fields) => {
                        shouldToggleComparisonRef.current = true;
                        fieldsToCompare = fields;
                    }}
                />
            )}
        </BroadcastMutations>
    );
}
